import { css, Theme, SerializedStyles } from "@emotion/react"

export const iconCss = css`
	height: 40px;
	width: 40px;
	color: #00050a;

	display: flex;
	width: 40px;
	height: 40px;
	padding: 8px;
	padding-top: 6px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex-shrink: 0;
	border-radius: 0;

	border-top: none;
	border-bottom: none;
	border-right: 0.5px solid #66696c;

	& svg {
		width: 1.2rem;
		height: 1.2rem;
		color: #00050a;
	}
`

export const autocompleteStyle = (theme: Theme): SerializedStyles => css`
	background: white;
	padding-bottom: 10px;
	border-radius: 0;
	width: 512px;
	height: 40px;
	border-radius: 0.5em;

	${theme.breakpoints.down("xs")} {
		width: 100%;
		margin-top: 10px;
	}

	${theme.breakpoints.down("sm")} {
		width: 100%;
	}

	.MuiAutocomplete-inputRoot {
		padding-right: 0;
		padding-left: 1em;

		.MuiAutocomplete-input {
			border-radius: 0;
			padding: 7px 10px;
		}
	}
`

export const optionImageStyle = css`
	max-height: 3em;
	margin-right: 0.5em;
	img {
		width: unset;
		max-height: 3em;
	}
`
